import { DEFER_SEARCH_TIMEOUT } from './constants';

// DEFER SEARCH
let searchTimeout: NodeJS.Timeout;
export const DEFER_SEARCH = (
  query: string,
  cb: (searchValue: string) => void,
  customTimeout?: number
) => {
  // Clear timeout
  clearTimeout(searchTimeout);

  // Defer action
  searchTimeout = setTimeout(
    () => {
      cb(query);
    },
    customTimeout !== undefined ? customTimeout : DEFER_SEARCH_TIMEOUT
  );
};

export const safeParseNumber = (
  input: string | undefined
): number | undefined => {
  if (input === undefined) return undefined;
  const result = parseInt(input);
  if (isNaN(result)) return undefined;
  return result;
};

export const parseNumberOrZero = (input: string | undefined): number => {
  const ret = Number(input);
  return isNaN(ret) ? 0 : ret;
};

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function stringOrNull(value: unknown): string | null {
  return isString(value) ? value : null;
}

export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const NOT_FOUND = -1;

export function firstOrNull<T>(input: T[] | null | undefined) {
  return input?.length ? input[0] : null;
}
